import React from "react";
import Message from "./GenericMessage";

const Loading = () => {
  return <Message title="Loading Portal&#8230;" loading={true} />;
};

export default Loading;
